import _ from 'underscore';

function validateBidBudgetInput(i18n, usePercentValidation, value, valueRange, localizedErrors) {
  const decimalValue = i18n.parseDecimal(value);
  if (_.isNaN(decimalValue)) {
    if (usePercentValidation) {
      return localizedErrors.invalidPercentageError;
    }
    return localizedErrors.invalidValueError;
  }

  const minValue = usePercentValidation ? 0 : valueRange.FloorValue;
  const maxValue = usePercentValidation ? Number.MAX_VALUE : valueRange.CeilingValue;

  if ((decimalValue < minValue && !usePercentValidation) ||
                    (decimalValue <= minValue && usePercentValidation) ||
                    decimalValue > maxValue) {
    return localizedErrors.outOfRangError;
  }

  return '';
}

export function validateBidInput(value, i18n, usePercentValidation, keywordBidRange) {
  return validateBidBudgetInput(
    i18n,
    usePercentValidation,
    value,
    keywordBidRange,
    {
      invalidPercentageError: i18n.getString('BulkEdit_Keyword_InvalidPercentageError'),
      invalidValueError: i18n.getString('BulkEdit_Keyword_InvalidBidError'),
      outOfRangError: i18n.getString('BulkEdit_Keyword_BidOutOfRangeError'),
    }
  );
}

export function validateBudgetInput(value, i18n, usePercentValidation, budgetRange) {
  return validateBidBudgetInput(
    i18n,
    usePercentValidation,
    value,
    budgetRange,
    {
      invalidPercentageError: i18n.getString('BulkEdit_Keyword_InvalidPercentageError'),
      invalidValueError: i18n.getString('BulkEdit_Campaign_InvalidBudgetError'),
      outOfRangError: i18n.getString('BulkEdit_Campaign_BudgetOutOfRangeError'),
    }
  );
}
